import React from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { string, number, PropTypes } from 'prop-types';
import { Button, FormGroup, Form } from 'reactstrap';
import FormItem from '../../../common/forms/FormItem';
import { isRequired, validateNumber } from '../../../../utils/validators';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';
import Select from '../../../common/forms/select/Select';
import { CREDIT_NOTE_MOTIVES } from '../../../../config/constants';
import { enumToSelectOptions } from '../../../../utils/enum';

const selector = formValueSelector('CreateCreditNoteParcelForm');

const CreateCreditNoteParcelForm = ({
  parcel,
  handleProcess,
  onCancel,
  handleSubmit,
  creditNoteMotiveValue,
}) => (
  <Form onSubmit={handleSubmit(handleProcess)}>
    <ResourceProperty label="Serie:">{parcel.documentSeries}</ResourceProperty>
    <ResourceProperty label="Número de serie:">
      {parcel.documentCode}
    </ResourceProperty>
    <ResourceProperty label="Origen:">{parcel.sourceCityName}</ResourceProperty>
    <ResourceProperty label="Destino:">
      {parcel.destinationCityName}
    </ResourceProperty>
    <hr />
    <FormGroup row>
      <FormItem label="Monto de Crédito" required>
        <Field
          name="creditNoteAmount"
          component={TextInput}
          type="text"
          placeholder="Monto de Crédito"
          validate={[isRequired, validateNumber]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Motivo de Generación" required>
        <Field
          name="creditNoteMotive"
          component={Select}
          options={enumToSelectOptions(CREDIT_NOTE_MOTIVES)}
          placeholder="Motivo de Generación"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    {creditNoteMotiveValue &&
      creditNoteMotiveValue.value === CREDIT_NOTE_MOTIVES.OTHERS.value && (
        <FormGroup row>
          <FormItem label="Observación de Generación" required>
            <Field
              name="creditNoteMotiveDescription"
              component={TextInput}
              type="textarea"
              placeholder="Observación de Generación"
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
      )}

    <FormFooter saveButtonColor="secondary" saveButtonIcon={null}>
      <Button color="primary" onClick={onCancel}>
        Cancelar
      </Button>
    </FormFooter>
  </Form>
);

const parcelPropTypes = {
  documentSeries: string,
  documentCode: number,
  sourceCityName: string,
  destinationCityName: string,
  paymentMethodId: number,
};

CreateCreditNoteParcelForm.propTypes = {
  parcel: PropTypes.shape(parcelPropTypes).isRequired,
  handleProcess: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  creditNoteMotiveValue: PropTypes.instanceOf(Object),
};

CreateCreditNoteParcelForm.defaultProps = {
  creditNoteMotiveValue: null,
};

const mapStateToProps = (state) => ({
  creditNoteMotiveValue: selector(state, 'creditNoteMotive'),
});

const formComponent = reduxForm({
  form: 'CreateCreditNoteParcelForm',
})(CreateCreditNoteParcelForm);

export default connect(mapStateToProps, null)(formComponent);
